import { Card, Breadcrumb, Icon } from 'antd'
import React, { Component } from 'react'
import MainBreadcrumb from "./MainBreadcrumb"
import Tips from '../Tips'

import './css/Notice.less'

import { tool } from 'rt-sd-common';
class Notice extends Component {
  componentDidMount(){
    window.MainBreadcrumb = this.refs.MainBreadcrumb;
    //let userId = tool.getCookie('userId');
    //console.log(`当前userId：${userId}`);
    //this.getUserInfo(userId)
  }

  getUserInfo = (userId) => {
    let req = { userId };
    let success = (res) => {
        if (res && res.head.code === "0000") {
            console.log('getUserInfo', res.body);
            const userNam = res.body.userNam
           // this.state.msgList = res.body ? res.body : [];
        }else{
           // message.warning(res.head.msg);
        }
    };
    commonClient.simplecall(sgiConfig.service_uam + `/user/getUserInfoByUserId`, req, success);
  }
  render() {
    return (
      <Card className="Notice">
        <MainBreadcrumb ref="MainBreadcrumb" />
        <Tips />
      </Card>
    )
  }
}

export default Notice




// WEBPACK FOOTER //
// ./apps/pages/main/layout/Notice.js